/* GSO PDP v2 Shopify interactions. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function moneyFromCents(cents) {
    if (!window.theme || !theme.Currency || !theme.settings) return '';
    return theme.Currency.formatMoney(parseInt(cents, 10), theme.settings.moneyFormat);
  }

  // Essential Upsell's "Frequently bought together" primary line has its own
  // React-controlled <select> and never syncs to our custom variant picker, so
  // the bundle would stay on the default bag size. Drive that select directly
  // (native value setter + input/change so React registers it) to the chosen
  // variant. Only touches the select that offers THIS product's variants; other
  // bundled products' selects are left alone.
  var nativeSelectValueSetter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value').set;
  // Returns true once this product's select has been found (whether or not it
  // needed changing), so callers can stop waiting for the widget to mount.
  // DealEasy exposes a documented hook for this: lb-dealeasy.js listens for
  // 'lb-dealeasy-variant-change' and re-renders the volume-discount table from
  // detail.currentVariantId. Verified live on 18 Aug 2026 against Traditional
  // Lawn and Ultimate, in both directions (offer -> no offer -> offer).
  // Deliberately NOT the Essential Upsell approach below: that app exposes no
  // event, so the FBT has to be driven through its own React select. Do not
  // copy that pattern here, it is not needed.
  function syncDealeasy(variantId) {
    if (!variantId) return;
    try {
      document.dispatchEvent(new CustomEvent('lb-dealeasy-variant-change', {
        detail: { currentVariantId: String(variantId) }
      }));
    } catch (e) { /* CustomEvent unsupported, the app's own URL observer covers it */ }
  }

  // The app renders nothing at all on a variant with no offer, leaving an empty
  // wrapper. CSS :has() handles it, this is the fallback for the same thing.
  function syncBulkEmpty(root) {
    var wrap = root.querySelector('[data-gso-bulk]');
    if (!wrap) return;
    wrap.classList.toggle('is-empty', !wrap.querySelector('.lb-vd-table'));
  }

  // The app redraws asynchronously after the event, and the shared observer
  // stops once the shopper touches the FBT, so re-check on our own schedule too.
  function recheckBulkEmpty(root) {
    [150, 600, 1500, 3000].forEach(function (ms) {
      setTimeout(function () { syncBulkEmpty(root); }, ms);
    });
  }

  function syncFbtPrimary(variantId) {
    if (!variantId) return false;
    var fbt = document.querySelector('[data-gso-fbt-app]');
    if (!fbt) return false;
    var id = String(variantId);
    var found = false;
    fbt.querySelectorAll('select').forEach(function (fs) {
      var offersThisProduct = Array.prototype.some.call(fs.options, function (o) { return o.value === id; });
      if (!offersThisProduct) return;
      found = true;
      if (fs.value !== id) {
        try {
          nativeSelectValueSetter.call(fs, id);
          fs.dispatchEvent(new Event('input', { bubbles: true }));
          fs.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) {}
      }
    });
    return found;
  }

  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        main.src = thumb.getAttribute('data-full') || (img && img.src) || main.src;
        main.alt = img ? img.alt : main.alt;
        thumbs.forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function setAddedState(button) {
    if (!button) return;
    button.classList.add('is-added');
    setTimeout(function () { button.classList.remove('is-added'); }, 1600);
  }

  function initProductForm(root) {
    var form = root.querySelector('.gso-product-form');
    var cards = root.querySelectorAll('[data-variant-card]');
    var select = root.querySelector('[data-gso-product-select]');
    var mainPrice = root.querySelector('[data-price-main]');
    var comparePrice = root.querySelector('[data-compare-main]');
    var saveLabel = root.querySelector('[data-save-main]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var atcMainText = root.querySelector('[data-atc-main] [data-add-to-cart-text]');
    var atcSticky = root.querySelector('[data-atc-sticky]');
    var paypal = root.querySelector('[data-pp-message]');

    function apply(card, silent) {
      if (!card || card.disabled || card.classList.contains('is-unavailable')) return;

      cards.forEach(function (item) {
        item.classList.toggle('is-active', item === card);
        item.setAttribute('aria-pressed', item === card ? 'true' : 'false');
      });

      var priceLabel = card.getAttribute('data-price-label') || moneyFromCents(card.getAttribute('data-price'));
      var compareLabel = card.getAttribute('data-compare-label');
      var saveLabelText = card.getAttribute('data-save-label');
      var size = card.getAttribute('data-size') || '';
      var variantId = card.getAttribute('data-variant-id');

      if (select && variantId) {
        select.value = variantId;
        if (!silent) {
          // Mirror theme.Variants so third-party integrations (Essential Upsell
          // "Frequently bought together", Shop Pay) re-sync to the chosen variant.
          // The custom card UI otherwise updates the select silently and nothing
          // listening for a variant change ever fires. Skipped on the initial
          // apply() so no synthetic change fires on page load.
          select.dispatchEvent(new Event('change', { bubbles: true }));
          if (window.history && history.replaceState) {
            var variantUrl = window.location.pathname + '?variant=' + variantId;
            history.replaceState({ path: variantUrl }, '', variantUrl);
          }
          syncFbtPrimary(variantId);
          syncDealeasy(variantId);
          recheckBulkEmpty(root);
        }
      }
      if (mainPrice) mainPrice.textContent = priceLabel;
      if (comparePrice) {
        comparePrice.textContent = compareLabel || '';
        comparePrice.style.display = compareLabel ? '' : 'none';
      }
      if (saveLabel) {
        saveLabel.textContent = saveLabelText || '';
        saveLabel.style.display = saveLabelText ? '' : 'none';
      }
      if (stickyPrice) stickyPrice.textContent = size + ' · ' + priceLabel;
      if (atcMainText) atcMainText.textContent = 'Add to cart · ' + priceLabel;
      if (atcSticky) atcSticky.textContent = 'Add · ' + priceLabel;
      if (paypal && card.getAttribute('data-price')) {
        paypal.setAttribute('data-pp-amount', (parseInt(card.getAttribute('data-price'), 10) / 100).toFixed(2));
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { apply(card); });
    });

    var active = root.querySelector('[data-variant-card].is-active') || cards[0];
    if (active) apply(active, true);

    // Keep the FBT's primary line in step with the buy box while the page
    // settles. This matters on FIRST LOAD, not just after a change: the buy box
    // honours the section's default_size but the FBT always mounts on the
    // product's FIRST variant, so without this the bundle offers a different bag
    // from the one selected above it.
    //
    // Syncing once is not enough. The widget mounts asynchronously (seconds),
    // and on some products it mounts, accepts the sync, then re-renders and
    // resets itself — so we re-assert on a short interval for a settling window
    // rather than stopping at the first success. Bail out permanently if the
    // shopper touches the select themselves; their choice wins over ours.
    // Stop enforcing the moment the shopper interacts with the bundle at all.
    // Their choice must win over ours: a customer who picks a different bag in
    // the FBT must not have it yanked back.
    //
    // Detect this from real interaction events (pointer/mouse/touch/key) inside
    // the widget, NOT from `change.isTrusted`. A change event alone cannot be
    // trusted as a discriminator: the app fires its own, and programmatic
    // selection can produce a change with no reliable trust signal. Genuine
    // human use always involves one of the input events below first.
    var fbtUserTouched = false;
    function markFbtTouched(e) {
      if (e.target && e.target.closest && e.target.closest('[data-gso-fbt-app]')) {
        fbtUserTouched = true;
      }
    }
    ['pointerdown', 'mousedown', 'touchstart', 'keydown'].forEach(function (type) {
      document.addEventListener(type, markFbtTouched, true);
    });

    // Do NOT drive this off a fixed time window. The widget's mount time is not
    // ours to predict: on a slow page it can appear well over a minute after
    // this script runs, and a 15s window simply expired before it existed.
    // Watch the DOM instead, so we react whenever the widget appears, re-renders
    // or remounts, however late that is.
    function currentVariantId() {
      var current = root.querySelector('[data-variant-card].is-active');
      return current && current.getAttribute('data-variant-id');
    }

    var fbtSyncQueued = false;
    function queueFbtSync() {
      if (fbtUserTouched || fbtSyncQueued) return;
      fbtSyncQueued = true;
      setTimeout(function () {
        fbtSyncQueued = false;
        if (!fbtUserTouched) syncFbtPrimary(currentVariantId());
      }, 120);
    }

    syncFbtPrimary(currentVariantId());
    syncBulkEmpty(root);

    // First-load sync for DealEasy. apply() runs SILENTLY on page load, so
    // nothing tells the app which bag the buy box opened on, and it falls back
    // to the product's FIRST variant. Found in the post-deploy crawl on 19 Aug
    // 2026: Hard Wearing opened on 10kg but the app sat on the 1.5kg, which has
    // no offer, so no table rendered; Wet Soils opened on 10kg but the app sat
    // on the 5kg, which DOES have an offer, so it rendered 5kg bulk prices
    // beside a 10kg buy box. The second one is a wrong price, not a missing one.
    //
    // Exactly the same class of bug as the Essential Upsell first-load mismatch
    // on 30 Jul, and the lesson from that one applies: the widget's mount time
    // is not ours to predict, so a single deferred call is a guess. Assert on a
    // widening backoff instead, and once more the first time a table actually
    // appears. Re-asserting the *currently selected* variant is always correct,
    // and unlike the FBT there is no control inside this widget for a shopper to
    // fight with, so no user-choice guard is needed.
    // Backstop only. The real fix is the inline URL write in the section prelude,
    // which means the app never resolves the wrong variant in the first place.
    // These assertions cover a shopper landing on an inbound ?variant= link that
    // disagrees with the rendered buy box, and cost nothing when they agree.
    [0, 600, 1800, 4000, 8000].forEach(function (ms) {
      setTimeout(function () { syncDealeasy(currentVariantId()); }, ms);
    });
    var dealeasySawTable = false;

    if (window.MutationObserver) {
      var fbtObserver = new MutationObserver(function () {
        // The bulk table mounts and re-renders on the app's own schedule, so
        // its empty state is re-checked on every mutation. Cheap, and it means
        // no timing assumption about when the widget appears.
        syncBulkEmpty(root);
        // One-shot: the first time a table exists, re-assert the selected
        // variant in case the app mounted later than the backoff above. A flag
        // rather than an unconditional re-assert, so our own dispatch cannot
        // drive the app into a render loop.
        if (!dealeasySawTable && root.querySelector('[data-gso-bulk] .lb-vd-table')) {
          dealeasySawTable = true;
          syncDealeasy(currentVariantId());
        }
        if (fbtUserTouched) { fbtObserver.disconnect(); return; }
        queueFbtSync();
      });
      // Observe the whole section: the app block's container is replaced
      // wholesale on mount, so observing only the inner node would miss it.
      fbtObserver.observe(root, { childList: true, subtree: true });
      // Stop eventually so we are not observing forever on an idle tab.
      setTimeout(function () { fbtObserver.disconnect(); }, 180000);
    }

    if (form && window.theme && theme.AjaxProduct && !form.dataset.gsoAjaxProduct) {
      form.dataset.gsoAjaxProduct = 'true';
      new theme.AjaxProduct(form, '[data-add-to-cart]');
      form.addEventListener('ajaxProduct:added', function (evt) {
        setAddedState(evt.detail && evt.detail.addToCartBtn);
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
    }

    if (form && atcSticky) {
      atcSticky.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  function initQty(root) {
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input || !minus || !plus) return;
      var max = parseInt(input.getAttribute('max'), 10) || 999;
      minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      plus.addEventListener('click', function () {
        input.value = Math.min(max, (parseInt(input.value, 10) || 1) + 1);
      });
    });
  }

  function initCompare(root) {
    root.querySelectorAll('[data-compare]').forEach(function (compare) {
      var after = compare.querySelector('.compare__after');
      var handle = compare.querySelector('.compare__handle');
      var range = compare.querySelector('.compare__range');
      if (!after || !handle || !range) return;
      function set(percent) {
        percent = Math.max(0, Math.min(100, percent));
        after.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
        handle.style.left = percent + '%';
      }
      range.addEventListener('input', function () { set(parseFloat(range.value)); });
      set(parseFloat(range.value || 50));
    });
  }

  function initStickyATC(root) {
    var bar = root.querySelector('[data-sticky-atc]');
    var anchor = root.querySelector('[data-atc-main]') || root.querySelector('[data-atc-anchor]');
    if (!bar || !anchor) return;
    var stickyButton = bar.querySelector('[data-atc-sticky]');
    var ticking = false;
    var badgeCandidates = null;

    function badgeElements() {
      if (badgeCandidates) return badgeCandidates;
      badgeCandidates = Array.prototype.slice.call(document.body.querySelectorAll('*')).filter(function (el) {
        if (root.contains(el) || bar.contains(el)) return false;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return false;
        var rect = el.getBoundingClientRect();
        return rect.width >= 36 &&
          rect.width <= 190 &&
          rect.height >= 24 &&
          rect.height <= 92 &&
          rect.left <= 150 &&
          rect.bottom >= window.innerHeight - 120;
      });
      return badgeCandidates;
    }

    function adjustFixedBadges(showing) {
      if (window.innerWidth > 768) return;
      badgeElements().forEach(function (el) {
        if (el.dataset.gsoPdpOriginalBottom === undefined) {
          el.dataset.gsoPdpOriginalBottom = el.style.bottom || '';
        }
        if (showing) {
          el.style.setProperty('bottom', '86px', 'important');
        } else {
          el.style.bottom = el.dataset.gsoPdpOriginalBottom;
        }
      });
    }

    function update() {
      ticking = false;
      var rect = anchor.getBoundingClientRect();
      var nearFooter = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 220);
      var showing = rect.bottom < 0 && !nearFooter;
      bar.classList.toggle('show', showing);
      bar.setAttribute('aria-hidden', showing ? 'false' : 'true');
      if (stickyButton) stickyButton.tabIndex = showing ? 0 : -1;
      document.body.classList.toggle('gso-pdp-v2-sticky-visible', showing);
      adjustFixedBadges(showing);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('resize', function () {
      badgeCandidates = null;
      update();
    });
    update();
  }

  function initCalc(root) {
    var form = root.querySelector('[data-calc]');
    if (!form) return;
    var input = form.querySelector('input');
    var out = form.querySelector('[data-calc-out]');
    if (!input || !out) return;
    var mode = form.getAttribute('data-calc-mode') || 'lawn';
    var toggles = form.querySelectorAll('[data-calc-preset]');

    function bindToggles(onPick) {
      if (!toggles.length) return;
      Array.prototype.forEach.call(toggles, function (btn) {
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(toggles, function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          onPick(btn.getAttribute('data-calc-preset'));
        });
      });
    }

    /* Paddock mode: input is acres, output is whole bags at N kg/acre,
       optionally with a full-reseed vs oversow toggle. */
    if (mode === 'paddock') {
      var bagKg = parseFloat(form.getAttribute('data-bag-kg')) || 10;
      var rateAcre = parseFloat(form.getAttribute('data-rate-acre')) || 14;
      var acrePresets = {
        'new': parseFloat(form.getAttribute('data-rate-acre')),
        'oversow': parseFloat(form.getAttribute('data-rate-acre-oversow'))
      };
      var calcPaddock = function () {
        var acres = parseFloat(input.value);
        if (!acres || acres <= 0) {
          out.innerHTML = 'Enter your paddock size to see how many bags you need.';
          return;
        }
        var bags = Math.ceil(acres * rateAcre / bagKg);
        out.innerHTML = 'You need <b>' + bags + ' &times; ' + bagKg + 'kg bag' + (bags > 1 ? 's' : '') +
          '</b> for <b>' + acres + ' acre' + (acres === 1 ? '' : 's') + '</b> at ' + rateAcre + ' kg/acre.';
      };
      bindToggles(function (key) {
        var r = acrePresets[key];
        if (!isNaN(r)) { rateAcre = r; calcPaddock(); }
      });
      input.addEventListener('input', calcPaddock);
      calcPaddock();
      return;
    }

    /* Lawn mode, optionally with a new-sow vs overseed toggle. */
    var rateLow = parseFloat(form.getAttribute('data-rate-low')) || 25;
    var rateHigh = parseFloat(form.getAttribute('data-rate-high')) || 35;
    var presets = {
      'new': [parseFloat(form.getAttribute('data-rate-low')), parseFloat(form.getAttribute('data-rate-high'))],
      'overseed': [parseFloat(form.getAttribute('data-rate-low-overseed')), parseFloat(form.getAttribute('data-rate-high-overseed'))]
    };
    function calc() {
      var area = parseFloat(input.value);
      if (!area || area <= 0) {
        out.innerHTML = 'Enter your lawn size to see how much seed you need.';
        return;
      }
      var lo = Math.round(area * rateLow / 1000 * 10) / 10;
      var hi = Math.round(area * rateHigh / 1000 * 10) / 10;
      out.innerHTML = 'You need roughly <b>' + lo + '–' + hi + ' kg</b> of seed for <b>' + area + ' m²</b>.';
    }
    bindToggles(function (key) {
      var p = presets[key];
      if (p && !isNaN(p[0]) && !isNaN(p[1])) { rateLow = p[0]; rateHigh = p[1]; calc(); }
    });
    input.addEventListener('input', calc);
    calc();
  }

  function initDetailLayer(root) {
    var planner = root.querySelector('[data-planner-target]');
    if (planner) {
      ['.tools-grid'].forEach(function (selector) {
        var block = root.querySelector(selector);
        if (!block || planner.contains(block)) return;
        var sourceSection = block.closest('[data-planner-section]') || block.closest('.pdp-section');
        block.classList.add('planner__moved-block');
        planner.appendChild(block);
        planner.classList.add('planner-shell--tools-only');
        if (sourceSection) sourceSection.hidden = true;
      });
    }

    var tabs = root.querySelector('[data-detail-tabs]');
    if (!tabs) return;
    var panels = Array.prototype.slice.call(tabs.querySelectorAll('[data-detail-target]'));
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-detail-tab]'));

    root.querySelectorAll('[data-detail-panel]').forEach(function (section) {
      var key = section.getAttribute('data-detail-panel');
      var target = tabs.querySelector('[data-detail-target="' + key + '"]');
      if (!target || target.contains(section)) return;
      section.classList.add('pdp-section--embedded');
      target.appendChild(section);
    });

    function activate(key, shouldScroll, hashId) {
      buttons.forEach(function (button) {
        var active = button.getAttribute('data-detail-tab') === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-detail-target') === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (shouldScroll) {
        var target = hashId ? document.getElementById(hashId) : tabs;
        if (target) setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 30);
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activate(button.getAttribute('data-detail-tab'), false);
      });
    });

    function activateForHash(shouldScroll) {
      var hash = window.location.hash ? window.location.hash.slice(1) : '';
      if (!hash) return false;
      var target = document.getElementById(hash);
      if (!target || !root.contains(target)) return false;
      var panel = target.closest('[data-detail-target]');
      if (!panel) return false;
      activate(panel.getAttribute('data-detail-target'), shouldScroll, hash);
      return true;
    }

    if (!activateForHash(false)) activate((buttons[0] && buttons[0].getAttribute('data-detail-tab')) || 'bag', false);
    window.addEventListener('hashchange', function () { activateForHash(true); });
  }

  ready(function () {
    document.querySelectorAll('[data-gso-pdp-v2]').forEach(function (root) {
      document.body.classList.add('gso-pdp-v2-active');
      initGallery(root);
      initProductForm(root);
      initQty(root);
      initDetailLayer(root);
      initCompare(root);
      initStickyATC(root);
      initCalc(root);
    });
  });
})();
